var _path, _path2, _path3, _path4, _g, _rect, _rect2, _g2, _rect3, _g3, _rect4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRecordsAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239,
    height: 137,
    viewBox: "0 0 239 137",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.4766 15.6543C40.4766 9.02688 45.8491 3.6543 52.4766 3.6543H174.477C181.104 3.6543 186.477 9.02688 186.477 15.6543V134.654H40.4766V15.6543Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.477 134.654V14.6543C187.477 8.57916 182.552 3.6543 176.477 3.6543H51.4766C45.4014 3.6543 40.4766 8.57917 40.4766 14.6543V134.654",
    stroke: "#D9D9D9",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.476562 134.654L226.477 134.654",
    stroke: "#D9D9D9",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4766 22.6543L187.477 22.6543",
    stroke: "#D9D9D9",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13873_25084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4766,
    y: 53,
    width: 106,
    height: 25,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4766,
    y: 53,
    width: 106,
    height: 25,
    rx: 7,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.4766,
    y: 62,
    width: 61,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4766,
    y: 62.2578,
    width: 18,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13873_25084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.477,
    y: 21,
    width: 97,
    height: 25,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.477,
    y: 21,
    width: 97,
    height: 25,
    rx: 7,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 30,
    width: 65,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13873_25084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.4766,
    y: 90,
    width: 106,
    height: 25,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.4766,
    y: 90,
    width: 106,
    height: 25,
    rx: 7,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 99,
    width: 73,
    height: 8,
    rx: 3,
    fill: "#E2E2E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.263 21.6469L231.263 21.6469C230.717 22.0533 230.575 22.8498 231.007 23.4177L231.263 21.6469ZM231.263 21.6469L231.267 21.6446M231.263 21.6469L231.267 21.6446M231.267 21.6446C232.942 20.4193 234.797 19.426 236.569 18.4927L236.569 18.4927M231.267 21.6446L236.569 18.4927M236.569 18.4927L236.57 18.4919M236.569 18.4927L236.57 18.4919M236.57 18.4919C237.172 18.1776 237.969 18.3727 238.283 19.0305C238.612 19.6489 238.358 20.4085 237.769 20.7229L237.769 20.7229M236.57 18.4919L237.769 20.7229M237.769 20.7229L237.766 20.7245M237.769 20.7229L237.766 20.7245M237.766 20.7245C236.042 21.6307 234.304 22.5559 232.776 23.6794M237.766 20.7245L232.776 23.6794M232.776 23.6794C232.218 24.0928 231.425 23.9673 231.007 23.4178L232.776 23.6794Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.364 3.79497L230.364 3.79507C230.989 4.05761 231.334 4.78685 231.037 5.45613C230.161 7.56729 229.135 9.5971 228.106 11.6028C228.02 11.7706 227.934 11.9383 227.848 12.1058C226.903 13.9473 225.965 15.7724 225.137 17.6483L225.137 17.6484L225.133 17.6573C224.839 18.2889 224.094 18.5794 223.451 18.299L223.439 18.2938L223.427 18.2879C222.86 18.0044 222.509 17.2886 222.816 16.621C223.659 14.7223 224.61 12.8769 225.554 11.0454C225.641 10.8768 225.728 10.7084 225.814 10.54C226.845 8.53736 227.856 6.54401 228.716 4.47838C228.974 3.827 229.727 3.52784 230.364 3.79497Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.591 13.5362C214.183 13.6667 213.77 13.4376 213.623 13.0423L212.464 6.79853C212.845 6.6807 213.287 6.90108 213.406 7.30652L215.082 12.5767C215.23 12.9717 215 13.4054 214.591 13.5362ZM212.317 6.32088C212.955 6.12338 213.682 6.48321 213.884 7.15967L215.555 12.4147C215.802 13.0964 215.396 13.8036 214.744 14.0124L214.743 14.0125C214.055 14.2326 213.386 13.8358 213.154 13.2174L213.15 13.2058L213.146 13.1939L211.467 7.91601L211.467 7.91605L211.463 7.90516C211.267 7.23533 211.648 6.53083 212.315 6.32149L212.315 6.32149L212.317 6.32088Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13873_25084",
    x: 8.47656,
    y: 51,
    width: 114,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13873_25084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13873_25084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13873_25084",
    x: 116.477,
    y: 19,
    width: 105,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13873_25084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13873_25084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13873_25084",
    x: 55.4766,
    y: 88,
    width: 114,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13873_25084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13873_25084",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordsAdded);
export default __webpack_public_path__ + "static/media/no-records-added.a695a43c.svg";
export { ForwardRef as ReactComponent };